'use client';

import { useEffect } from 'react';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => { console.error('[app error boundary]', error); }, [error]);
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
      <h2 className="text-lg font-semibold text-zinc-900">Что-то пошло не так</h2>
      <p className="max-w-xl text-sm text-red-600 break-words">{error?.message || 'Неизвестная ошибка'}</p>
      {error?.stack && (
        <details className="max-w-2xl text-left">
          <summary className="cursor-pointer text-xs text-zinc-500">Подробнее (для диагностики)</summary>
          <pre className="mt-2 max-h-64 overflow-auto whitespace-pre-wrap rounded bg-zinc-100 p-3 text-[11px] text-zinc-700">{error.stack}</pre>
        </details>
      )}
      <div className="flex gap-2">
        <button onClick={() => reset()} className="rounded-md bg-zinc-900 px-4 py-2 text-sm font-medium text-white">Повторить</button>
        <button onClick={() => history.back()} className="rounded-md border px-4 py-2 text-sm">Назад</button>
      </div>
    </div>
  );
}
